/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'ai-summary-label': '總結',
  'copy-content-link-label': '複製連結',
  'dynamic-cards-search-page.advanced-search.labels.filter.no.text': '開始輸入以搜尋標籤',
  'dynamic-cards-search-page.app-filter-sidebar.all': '全部',
  'dynamic-cards-search-page.app-filter-sidebar.group': '按產品篩選搜尋內容',
  'dynamic-cards-search-page.atlas.for': '適用於',
  'dynamic-cards-search-page.avatar': '頭像',
  'dynamic-cards-search-page.calendar-event-search-result.calendar-label': '行事曆',
  'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': '加入會議',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link': '會議連結',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': '加入會議',
  'dynamic-cards-search-page.calendar-event-search-result.past-events-button': '過去的事件',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': '週期性事件',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': '週期性',
  'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': '即將到來的事件',
  'dynamic-cards-search-page.compass.owner-name': '負責人：{ownerName}',
  'dynamic-cards-search-page.compass.state': '{state}',
  'dynamic-cards-search-page.compass.tier': '層級：{tier}',
  'dynamic-cards-search-page.confluence.filter.content.placeholder': '尋找內容',
  'dynamic-cards-search-page.confluence.filter.content.selected': '已選取',
  'dynamic-cards-search-page.confluence.filter.content.unselected': '建議',
  'dynamic-cards-search-page.confluence.filter.contributor.label.selected': '已選取',
  'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': '建議',
  'dynamic-cards-search-page.confluence.filter.contributor.placeholder': '尋找人員',
  'dynamic-cards-search-page.confluence.filter.label.selected': '已選取',
  'dynamic-cards-search-page.confluence.filter.labels.placeholder': '尋找標籤',
  'dynamic-cards-search-page.confluence.filter.space.placeholder': '尋找空間',
  'dynamic-cards-search-page.connect_third_party_product_description': '連接您的帳戶以查看缺少的結果',
  'dynamic-cards-search-page.connect_third_party_product_title': '您的管理員已新增 {product}！',
  'dynamic-cards-search-page.connect_third_party_product_title_alternate': '{product} 已可供使用！',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.end': '開始日期必須在結束日期之前',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.today': '開始日期不能是未來',
  'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today': '結束日期不能是未來',
  'dynamic-cards-search-page.date.filter.last.month': '過去 30 天內',
  'dynamic-cards-search-page.date.filter.last.week': '過去 7 天內',
  'dynamic-cards-search-page.date.filter.last.year': '過去一年內',
  'dynamic-cards-search-page.document-search-result.google-slides-label': '簡報',
  'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'Powerpoint',
  'dynamic-cards-search-page.document-search-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.dropdown_generate_answer': '產生答案',
  'dynamic-cards-search-page.dropdown_recent_icon_label': '最近',
  'dynamic-cards-search-page.error_primary': '我們在搜尋時遇到問題',
  'dynamic-cards-search-page.error_secondary': '這可能只是一個小問題。最好的做法就是<btn>再試一次</btn>。',
  'dynamic-cards-search-page.externalPeopleLabel': '外部人員 #{channelName}',
  'dynamic-cards-search-page.filter.clear.filter.label': '清除篩選條件',
  'dynamic-cards-search-page.filter.last.updated.anytime': '任何時間',
  'dynamic-cards-search-page.filter.last.updated.past30Days': '過去 30 天內',
  'dynamic-cards-search-page.filter.last.updated.past7Days': '過去 7 天內',
  'dynamic-cards-search-page.filter.last.updated.pastYear': '過去一年內',
  'dynamic-cards-search-page.filter.last.updated.today': '今天',
  'dynamic-cards-search-page.filter.last.updated.yesterday': '昨天',
  'dynamic-cards-search-page.filter.type.answer': '回答',
  'dynamic-cards-search-page.filter.type.attachment': '附件',
  'dynamic-cards-search-page.filter.type.blogpost': '部落格貼文',
  'dynamic-cards-search-page.filter.type.branch': '分支',
  'dynamic-cards-search-page.filter.type.calendar': '行事曆',
  'dynamic-cards-search-page.filter.type.comment': '留言',
  'dynamic-cards-search-page.filter.type.commit': '許可',
  'dynamic-cards-search-page.filter.type.component': '元件',
  'dynamic-cards-search-page.filter.type.conversation': '對話',
  'dynamic-cards-search-page.filter.type.database': '資料庫',
  'dynamic-cards-search-page.filter.type.design': '設計',
  'dynamic-cards-search-page.filter.type.documents': '文件',
  'dynamic-cards-search-page.filter.type.embed': '智慧連結',
  'dynamic-cards-search-page.filter.type.folder': '資料夾',
  'dynamic-cards-search-page.filter.type.issue': '議題',
  'dynamic-cards-search-page.filter.type.message': '訊息',
  'dynamic-cards-search-page.filter.type.page': '頁面',
  'dynamic-cards-search-page.filter.type.placeholder': '尋找類型',
  'dynamic-cards-search-page.filter.type.presentation': '簡報',
  'dynamic-cards-search-page.filter.type.pull-request': '提取要求',
  'dynamic-cards-search-page.filter.type.question': '問題',
  'dynamic-cards-search-page.filter.type.repository': '存放庫',
  'dynamic-cards-search-page.filter.type.space': '空間',
  'dynamic-cards-search-page.filter.type.space-calendar': '空間行事曆',
  'dynamic-cards-search-page.filter.type.spreadsheet': '試算表',
  'dynamic-cards-search-page.filter.type.video': '影片',
  'dynamic-cards-search-page.filter.type.web-page': '網頁',
  'dynamic-cards-search-page.filter.type.whiteboard': '白板',
  'dynamic-cards-search-page.filters.dropdown.clear-all': '全部清除',
  'dynamic-cards-search-page.filters.dropdown.title': '篩選條件',
  'dynamic-cards-search-page.filters.names.content': '底下的內容',
  'dynamic-cards-search-page.filters.names.contributor': '參與者',
  'dynamic-cards-search-page.filters.names.labels': '標籤',
  'dynamic-cards-search-page.filters.names.titleMatchOnly': '標題比對',
  'dynamic-cards-search-page.github-branch-result.label': '分支',
  'dynamic-cards-search-page.github-commit-result.label': '提交',
  'dynamic-cards-search-page.github-pull-request-result.label': '提取要求',
  'dynamic-cards-search-page.input_placeholder_search_only': '搜尋任何內容',
  'dynamic-cards-search-page.jira.filter.project.placeholder': '尋找專案',
  'dynamic-cards-search-page.landing_primary': '開始使用動態卡片的篩選條件',
  'dynamic-cards-search-page.legacy-third-party-result.google-docs-label': '文件',
  'dynamic-cards-search-page.legacy-third-party-result.google-sheets-label': '試算表',
  'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'Powerpoint',
  'dynamic-cards-search-page.legacy-third-party-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
  'dynamic-cards-search-page.no_results_primary': '我們找不到與您搜尋相符的結果',
  'dynamic-cards-search-page.no_results_secondary_some_filters_applied':
    '您似乎已套用一些篩選條件，您可以試著清除這些條件。',
  'dynamic-cards-search-page.nouns.goal': '目標',
  'dynamic-cards-search-page.nouns.goals': '目標',
  'dynamic-cards-search-page.nouns.tag': '標記',
  'dynamic-cards-search-page.nouns.tags': '標記',
  'dynamic-cards-search-page.number_of_results': '顯示 {numberOfResults,number} 筆結果 (共 {totalCount,number} 筆)',
  'dynamic-cards-search-page.oauth-banner.authorization-fail': '{product} 的授權失敗。',
  'dynamic-cards-search-page.oauth-banner.authorization-success': '{product} 的授權成功。',
  'dynamic-cards-search-page.oauth-message-connect': '連結',
  'dynamic-cards-search-page.products.custom-website': '網頁',
  'dynamic-cards-search-page.results-sort.createdDate.selected': '依建立時間排序 (最新)',
  'dynamic-cards-search-page.results-sort.createdDateDESC': '建立時間 (最新)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': '更新時間 (最新)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected': '依更新時間排序 (最新)',
  'dynamic-cards-search-page.results-sort.sort-options.label': '變更列表排序',
  'dynamic-cards-search-page.rovo-onboarding-next': '下一步',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description': '按產品篩選，以獲得更相關的搜尋結果。',
  'dynamic-cards-search-page.rovo-onboarding-step-1-heading': '在所有的公司工作區中搜尋',
  'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description':
    '根據您篩選的產品，這些選項會變更以協助您取得特定結果。',
  'dynamic-cards-search-page.rovo-onboarding-step-2-heading': '找到您正在尋找的內容',
  'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
  'dynamic-cards-search-page.search-result.attachment-label': '附件',
  'dynamic-cards-search-page.search-result.attachments.attached-date.label': '已於 {formattedDate} 附加',
  'dynamic-cards-search-page.search-result.attachments.audio-label': '音訊',
  'dynamic-cards-search-page.search-result.attachments.image-label': '圖片',
  'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
  'dynamic-cards-search-page.search-result.last-modified': '更新日期：{formattedDate}',
  'dynamic-cards-search-page.search-result.private-channel-label': '私人頻道',
  'dynamic-cards-search-page.search-result.remove-recent-search': '移除最近搜尋圖示',
  'dynamic-cards-search-page.search-result.repository-label': '存放庫',
  'dynamic-cards-search-page.search-result.thread-title-wth-others':
    '{contributorCount, plural, =0 {與外部使用者通訊的群組訊息} =2 {{name1} 和 {name2}} =3 {{name1}、{name2} 和 {name3}} =4 {{name1}、{name2}、{name3} 和其他 {overflowContributorCount} 人} other {{name1}、{name2}、{name3} 和其他 {overflowContributorCount} 人}}',
  'dynamic-cards-search-page.search-result.unknown-channel-in-thread': '未知頻道',
  'dynamic-cards-search-page.search_result_type_answer': '答案',
  'dynamic-cards-search-page.search_result_type_card': '卡片',
  'dynamic-cards-search-page.search_result_type_commit': '許可',
  'dynamic-cards-search-page.search_result_type_component': '元件',
  'dynamic-cards-search-page.search_result_type_embed': '智慧連結',
  'dynamic-cards-search-page.search_result_type_folder': '資料夾',
  'dynamic-cards-search-page.search_result_type_presentation': '簡報',
  'dynamic-cards-search-page.search_result_type_pull_request': '提取要求',
  'dynamic-cards-search-page.search_result_type_sharepoint_document': 'Sharepoint 文件',
  'dynamic-cards-search-page.search_result_type_space_calendar': '空間行事曆',
  'dynamic-cards-search-page.search_result_type_spreadsheet': '試算表',
  'dynamic-cards-search-page.search_result_type_unrecognised': '無法辨識',
  'dynamic-cards-search-page.search_result_type_work_item': '工作項目',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product':
    '您的管理員已新增 <strong>{product}！</strong>{br}請連結帳戶以查看缺少的結果，包括只有您可以存取的文件。',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate':
    '<strong>{product} 已可供使用！</strong>{br}連接您的帳戶以查看缺少的結果，包括只有您可以存取的文件。',
  'dynamic-cards-search-page.sidebar-oauth-warning-authorize': '授權',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail': '{product} 的授權失敗。',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success': '{product} 的授權成功。',
  'dynamic-cards-search-page.tab-filter.all-filter-visual-label': '依所有應用程式篩選',
  'dynamic-cards-search-page.tab-filter.more-dropdown-label': '按照更多應用程式篩選',
  'dynamic-cards-search-page.townsquare.api.goal-state.archived': '已封存',
  'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': '有風險',
  'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': '已取消',
  'dynamic-cards-search-page.townsquare.api.goal-state.completed': '已完成',
  'dynamic-cards-search-page.townsquare.api.goal-state.off-track': '偏離預期',
  'dynamic-cards-search-page.townsquare.api.goal-state.on-track': '進度正常',
  'dynamic-cards-search-page.townsquare.api.goal-state.paused': '已暫停',
  'dynamic-cards-search-page.townsquare.api.goal-state.pending': '擱置中',
  'dynamic-cards-search-page.video-search-result.dropdown-message':
    '{chapterCount, plural, other {本影片中有 {chapterCount,number} 個章節}}',
  'dynamic-cards-search-page.video-search-result.video-icon-label': '影片圖示',
  'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': '影片縮圖',
  'dynamic-cards-search-page.work-item-assignee.assigned': '已指派',
  'dynamic-cards-search-page.work-item-creator.created': '已建立',
  'dynamic-cards-search-page.work-item-status.for': '：',
  'dynamic-cards-search-page.work-item-ticket.label': '工單',
  'dynamic-cards-search-page.work-item.label': '工作項目',
  'initialsAvatar.label': '首字母縮寫頭像',
  'personAvatar.label': '人物頭像',
  'search-page.results.private-result-label': '私密',
  'search-page.results.private-result-tooltip': '只有您能夠看見',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, other {{memberCount,number} 位成員}}',
  'search-page.results.product-results.third-party.channel-type-label': '頻道',
  'search-page.results.product-results.third-party.conversation-search-result.label': '頻道',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, other {{count,number} 位成員}}',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    '上次使用時間：{formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': '未知頻道',
  'search-page.results.product-results.third-party.external-people-label': '外部人員',
  'search-page.results.product-results.third-party.external-person-label': '外部人員',
  'search-page.results.product-results.third-party.last-active': '上次使用時間：{relativeDate}',
  'search-page.results.product-results.third-party.message-type-label': '訊息',
  'search-page.results.product-results.third-party.no-contributors-label': '# {channelName} 中的外部人員',
  'search-page.results.product-results.third-party.private-conversation-text': '私人對話中的 {users}',
  'search-page.results.product-results.third-party.thread-type-label': '討論串',
  'search-page.results.product-results.third-party.title-and-channel-name': '#{channelName} 中的 {title}',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{remainingContributorsCount, plural, other {{title} 和其他 {remainingContributorsCount} 人}}',
  'search-page.results.restricted-result-label': '受限制',
  'search-page.results.restricted-result-tooltip': '只有特定人員才能看見',
  'search-page.show-more-breadcrumbs-button-label': '顯示更多軌跡瀏覽',
  'search-page.verified-icon-label': '已驗證',
  'search-page.verified-icon-tooltip-message': '此頁面已經由負責人或管理員驗證。',
  'search-result.result.count': '{count, plural, other {正在顯示 {count} 筆結果}}',
  'search-result.user-mention.external-person': '外部人員',
};
